import { EEventType } from './../../enums/EEventType';
import styles from './index.module.less';
import template from './index.art';
import OY from '../../types/OY';
import { IOYCheckboxPropData, IOYCheckboxProps, IOYCheckboxState } from './const';
import { valueIncludes } from '../../utils';
import { jeact } from '../../decorators/jeact';
import { IValueData } from 'data';
import { ECheckMode } from '../../enums/ECheckMode';

@jeact()
export default class OYCheckbox2 extends OY<IOYCheckboxProps, IOYCheckboxState> {
  static displayName = 'OYCheckbox2';

  static defaultProps: Partial<IOYCheckboxProps> = {
    value: [],
    info: [],
    splitIndeterminate: false,
    box: true,
    mode: ECheckMode.Checkbox
  }

  public state: IOYCheckboxState = {
    titleWidth: '',
    contentWidth: '',
    itemWidth: '',
    checkAll: false,
    indeterminateData: undefined,
    checkboxData: []
  };

  public $el: JQuery = $();

  $node = {
    indeterminate: $(),
    indeterminateInput: $(),
    item: $(),
    input: $()
  }

  preValue: string[] = [];

  getDerivedStateFromProps(props: IOYCheckboxProps, state: IOYCheckboxState) {
    const dstate = this._dealProps(props);
    return { ...state, ...dstate };
  }

  render() {
    return template({ props: this.props, state: this.state, styles })
  }

  componentDidMount() {
    const { collapse } = this.props;
    if (collapse && collapse > 0) {
      const $td = this.$class(styles.oy_chekcbox_tdWrapper);
      const $tr = $td.parents(`.${styles.tr}`);
      const wrapperHeight = $td.innerHeight();
      const maxHeight = this.$node.item.outerHeight() * collapse;
      if (wrapperHeight > maxHeight) {
        const button = $('<div/>').OYButton({
          text: '更多', icon: 'down', size: 'small', type: 'ghost', attrs: { style: 'width: 58px' },
          onClick: () => {
            if (button.props.text === '更多') {
              button.setProp({ text: '收起', icon: 'up' });
              $td.css({ 'max-height': '1000px' })
            } else {
              button.setProp({ text: '更多', icon: 'down' });
              $td.css({ 'max-height': maxHeight + 'px' })
            }
          }
        });
        const $butonTD = $(`<div/>`).addClass(styles.td).addClass(styles.oy_chekcbox_td).addClass('oy-checkbox2-td').css({ width: '58px' }).append(button.$el);
        $tr.append($butonTD);
        $td.css({ 'max-height': maxHeight + 'px' })
      }
      // console.log(this.$node.item.outerHeight())
    }
  }

  setNode(): void {
    this.$node = {
      indeterminate: this.$el.find(`.${styles.indeterminate}`),
      indeterminateInput: this.$el.find(`.${styles.indeterminate} input`),
      item: this.$el.find(`.${styles.oy_chekcbox_item}`),
      input: this.$el.find(`.${styles.oy_chekcbox_item} input`)
    }
  }

  protected bindCheckbox() {
    // FIXED: 这里不能使用node.input 否则会有问题
    this.$el.delegate(`.${styles.oy_chekcbox_item}`, 'click', (ev: Event) => {
      const values: string[] = [];
      const $target = $(ev.currentTarget!);

      if (this.props.mode === ECheckMode.Checkbox) {
        // 切换样式
        const checked = $target.toggleClass(styles.checked).hasClass(styles.checked);
        $target.find('input').prop({ checked })

        this.$node.item.filter(`.${styles.checked}`).each((_idx, element) => {
          values.push($(element).data('value'))
        })

        // 设置全选状态
        if (values.length !== this.$node.input.length) {
          this._setIndeterminate(false)
          this.emitChange(values)
        } else {
          this._setIndeterminate(true)
          if (this.state.indeterminateData && this.state.indeterminateData.value) {
            this.emitChange([this.state.indeterminateData.value])
          } else {
            this.emitChange(values)
          }
        }
      } else {
        const value = `${$target.data('value')}`;
        // 取消选中
        if ($target.hasClass(styles.checked)) {
          this._removeItemChecked($target);
          this.$node.item.filter(`.${styles.checked}`).each((_idx, element) => {
            const checkedValue = `${$(element).data('value')}`;
            if (checkedValue !== value) {
              values.push(checkedValue)
            }
          });
          this.emitChange(values, true)
        } else {
          this._setCheckAllItem(false);
          this._setItemChecked($target);
          this.emitChange([value])
        }
      }
    })
  }

  protected bindCheckAll() {
    this.$node.indeterminate.click((ev: Event) => {
      const $this = $(ev.currentTarget!);
      const allValue = $this.data('value');

      if (this.props.mode === ECheckMode.Checkbox) {
        if ($this.hasClass(styles.checked)) {
          this._setCheckAllItem(false)
          this.emitChange([])
        } else {
          this._setCheckAllItem(true)

          allValue ?
            this.emitChange([allValue]) :
            this.emitChange(this.state.checkboxData.map(va => va.value));
        }
      } else {
        if ($this.hasClass(styles.checked)) {
          return this.emitChange([], true);
        }
        if (!allValue) {
          this.emitChange(this.state.checkboxData.map(va => va.value));
        } else {
          this._removeAllItemChecked();
          this._setItemChecked($this);
          this.emitChange([allValue])
        }
      }
    })
  }

  private emitChange(value: string[], isCancel = false) {
    // eslint-disable-next-line no-param-reassign
    value = value.map(va => `${va}`)
    const { beforeChange } = this.props
    if (beforeChange) {
      const result = beforeChange(value);
      if (result) {
        this.eventEmitter.emit(EEventType.onChange, value, isCancel)
        this.preValue = value;
      } else {
        // 执行回滚
        this.$node.input.each((_id, element) => {
          const $ele = $(element);
          const dataValue = `${$ele.parent().data('value')}`;
          if (valueIncludes(this.preValue, dataValue)) {
            $ele.prop({ checked: true });
          } else {
            $ele.prop({ checked: false });
          }
        })
        this.$node.indeterminateInput.prop({ checked: value.length === this.preValue.length });
      }
    } else {
      this.eventEmitter.emit(EEventType.onChange, value, isCancel)
      this.preValue = value;
    }
  }

  private _dealProps(props: IOYCheckboxProps) {
    const state: Partial<IOYCheckboxState> = {};
    const { splitIndeterminate, info, value, cells, width } = props;
    if (!info.length) {
      return;
    }

    // 拆分数据
    let indeterminateData: any;
    const checkboxData = info.filter(va => {
      if (this._isIndeterminateData(va)) {
        indeterminateData = va;
        return false;
      }
      return true;
    }) as IValueData[];

    // 判断全选状态
    if (indeterminateData) {
      // 自身携带value。
      if (indeterminateData.value) {
        state.checkAll = valueIncludes(value, indeterminateData.value)
      } else {
        // 自身不携带value。判断选中长度
        state.checkAll = value.length === checkboxData.length;
      }
    }

    // 计算宽高
    if (splitIndeterminate) {
      if (cells) {
        state.titleWidth = `${100 / cells}%`;
        state.itemWidth = `${100 / (cells - 1)}%`
      } else if (width) {
        state.titleWidth = `${width}px`;
        state.itemWidth = `${width}px`
      } else {
        state.titleWidth = `180px`
        state.itemWidth = `180px`
      }
    } else {
      if (cells) {
        state.itemWidth = `${100 / cells}%`
      } else if (width) {
        state.itemWidth = `${width}px`
      } else {
        state.itemWidth = `180px`
      }
    }

    return { ...state, indeterminateData, checkboxData };
  }

  private _isIndeterminateData(data: IValueData | IOYCheckboxPropData): data is IOYCheckboxPropData {
    return (data as IOYCheckboxPropData).indeterminate !== undefined;
  }

  private _setIndeterminate(checked: boolean) {
    this.$node.indeterminateInput.prop({ checked })
    this._setState({ checkAll: checked })
    if (checked) {
      this.$node.indeterminate.addClass(styles.checked)
    } else {
      this.$node.indeterminate.removeClass(styles.checked)
    }
  }

  private _setCheckAllItem(checked: boolean) {
    this._setIndeterminate(checked);
    if (checked) {
      this.$node.item.addClass(styles.checked).find('input').prop({ checked })
    } else {
      this.$node.item.removeClass(styles.checked).find('input').prop({ checked })
    }
  }

  private _removeAllItemChecked() {
    this.$node.item.removeClass(styles.checked).find('input').prop({ checked: false })
  }

  private _setItemChecked(item: JQuery) {
    item.addClass(styles.checked).find('input').prop({ checked: true })
  }

  private _removeItemChecked(item: JQuery) {
    item.removeClass(styles.checked).find('input').prop({ checked: false })
  }
}



// WEBPACK FOOTER //
// ./src/components/OYCheckbox2/index.ts